import Image from "next/image";
import React from "react";
import Slider from "react-slick";
import { TrustpilotMini } from "staysure-component-library";

interface Badge {
  src: string;
  alt: string;
  width: number;
  height: number;
  className: string;
  description: string;
}

interface SimpleSliderProps {
  trustpilotData: {
    stars: number;
    score: number;
    totalReviews: string;
    link: string;
    ratingLabels: {
      poor: string;
      fair: string;
      good: string;
      veryGood: string;
      excellent: string;
    };
    reviewsText: string;
  };
  badges: Badge[];
}

function SimpleSlider({ trustpilotData, badges }: Readonly<SimpleSliderProps>) {
  return (
    <div className="slider-container w-full max-w-[600px] mx-auto h-auto ">
      <Slider
        dots={false}
        arrows={false}
        infinite={true}
        autoplay={true}
        speed={500}
        slidesToShow={2}
        autoplaySpeed={1500}
        slidesToScroll={1}
        variableWidth={false}
        responsive={[
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false,
              variableWidth: false,
            },
          },
        ]}
      >
        {/* Trustpilot Slide */}

        <div className="w-fit px-[24px]">
          <div className="mb-6">
            <TrustpilotMini
              stars={trustpilotData.stars}
              score={trustpilotData.score}
              totalReviews={trustpilotData.totalReviews}
              link={trustpilotData.link}
              ratingLabels={trustpilotData.ratingLabels}
              reviewsText={trustpilotData.reviewsText}
            />
          </div>
          <p className="text-3xs leading-normal text-center">
            We've got more 5 Star reviews on Trustpilot than any other travel
            insurance provider
          </p>
        </div>

        {/* Badge Slides */}
        {badges.map((badge, index) => (
          <div key={badge.alt} className="w-fit px-6 flex flex-col">
            <Image
              key={`${badge.src}-${index}`}
              src={badge.src}
              alt={badge.alt}
              width={badge.width}
              height={badge.height}
              className={badge.className}
              priority
            />
            {badge.description && (
              <div>
                <p className="text-3xs leading-normal text-center">
                  {badge.description}
                </p>
              </div>
            )}
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default SimpleSlider;
